import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/notifications/admin/adminNotificationTemplateQueryKeys.ts
var t = e("admin-notification-templates", {
	list: (e) => e ? ["list", e] : ["list"],
	detail: (e) => ["detail", e]
});
//#endregion
export { t as adminNotificationTemplateQueryKeys };
